/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Hide category text and expand icons",
  "description": "Removes the text labels from block categories and expands the icon/bubble to fill the space. Includes settings to adjust the spacing between icons and their scale.",
  "tags": [
    "theme",
    "toolbox",
    "MistWarp"
  ],
  "enabledByDefault": false,
  "dynamicDisable": true,
  "userstyles": [
    {
      "url": "userstyle.css"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "settings": [
    {
      "dynamic": true,
      "name": "Icon spacing (10-200%)",
      "id": "iconSpacing",
      "type": "integer",
      "min": 10,
      "max": 200,
      "default": 50
    },
    {
      "dynamic": true,
      "name": "Icon scale (50-300%)",
      "id": "iconScale",
      "type": "integer",
      "min": 50,
      "max": 300,
      "default": 100
    }
  ],
  "credits": [
    {
        "name": "Mistium",
        "url": "https://mistium.com"
    }
  ]
};
export default manifest;
